import counterHelperMixin from './counterHelperMixin'

export default {

    mixins: [counterHelperMixin],

    props: {
        counter: {
            type: Object,
            required: true
        }
    },

    computed: {

        subtitle() {
            return this.createSubtitle(this.counter)
        },

        guid() {
            return this.counter.guid
        },

        prev() {
            return this.counter.prev
        },

        consum() {

           return this.calcConsum(this.current, this.counter.prev, this.scale, this.bit)
   
        },

        bit() { //десятичная частьь
            return this.counter.fraction
          },
    
        scale() { //целая часть
            return this.counter.capacity
        },

        maxConsum() {
            return this.counter.maxConsum
        },

        changed() {
            return this.current != this.counter.current
        },

        canUndo() {

            if (!this.counter.current) 
                return false

            return this.current.toString() != this.counter.current.toString()
        },

        message() {
            return this.counter.message || "Ввод показаний закрыт поставщиком"
        },


        canReading() {
            return this.counter.canReading
        }
    },

    data() {
        return {
            current: '',
            currentRules: [
                v => !!v || "Необходимо ввести показание",

            ]
        }
    },

    methods: {




        undo() {

            if (this.canUndo) {


                this.current = this.counter.current

            }

        },



        isConsumWarning() {
            return  (this.maxConsum > 0) && (this.consum > this.maxConsum)
        },

        isConsumError() {
            let halfCounter = Math.pow(10, this.scale) / 2
            return /* !canReading || */ (this.consum && this.consum > halfCounter)
        },


        isDigit(keyCode) {
            return (48 <= keyCode && keyCode <= 57) || (96 <= keyCode && keyCode <= 105)
        },


/*         inputHandler2(e) {


            if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(e.key)) {


                e.pre
            }

        }, */


        inputHandler(e) {


            let start = e.target.selectionStart
            let end = e.target.selectionEnd

            let cur = this.current.toString() || '';

            let hasBit = this.bit && this.bit > 0;

            if (e.key == "." && hasBit) {

                if (cur.length == 0) {
                    cur = "0."
                }

                if (cur.indexOf(".") == -1) {
                    cur = cur + '.'
                }

                this.current = cur;
            }

            if (this.isDigit(e.keyCode)) {

                if (cur == "0") {
                    if (e.key != "0") {
                        this.current = e.key;

                    }
                    return;
                }

                let maxLen = (hasBit && cur.indexOf(".") > -1) ?
                    cur.indexOf(".") + this.bit + 1 :
                    this.scale;

                if (cur.length < maxLen) {
                    this.current = cur + e.key;
                }
            }

            if (e.keyCode == 8) {

                cur = cur.substr(0, cur.length - 1);
                this.current = cur;
            } //backspace 
        }

    }
}